<hs-loading-spinner
  [color]="'primary'"
  [size]="120"
  [message]="text"
></hs-loading-spinner>
